import React, { lazy, useEffect, useState } from 'react';
import { Navbar, Card } from 'react-bootstrap';

import { TokenVerificationService } from './core/services/token-verification';
import { OperationComponentsLoader } from './core/services/operation-components-loader';
import { ConfigurationService } from './core/services/configuration';
import { Loader } from './shared/Loader';

import './App.scss';

const loadComponent = (opId, status) => {
  const componentPath = OperationComponentsLoader.getComponentPath(opId, status);
  return lazy(() => import(`./components/${componentPath}`));
}

const App = () => {

  const [ resultView, setResultView ] = useState();
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {  
    async function verifyToken() {
      const queryParams = new URLSearchParams(window.location.search);
      let opId = atob(queryParams.get('opId') || '');
      let status = 0;

      const configurationService = new ConfigurationService();
      const configuration = await configurationService.load();
      const operationConfiguration = configurationService.getOperationConfiguration(opId);

      try {
        const response = await TokenVerificationService.verify(
          configuration.tokenVerificationServiceUrl,
          queryParams.get('ref'),
          { apiKey: configuration.apiKey },
        );
        status = response.status;
      } catch(e) {
        const response = e.response || { status: 0 };
        status = response.status;
      }

      const Component = await loadComponent(opId, status);
      setResultView(<Component operation={opId} configuration={operationConfiguration} />);
      setLoading(false);
    }

    verifyToken();
  }, [])

  return (
    <div className="container-fluid px-0 px-md-5">
      { loading ? <Loader /> : null }
      <Navbar className="justify-content-center justify-content-lg-between my-3 mb-md-5 px-5">
        <Navbar.Brand href="https://www.infocert.it">
          <img
            src="https://assets.infocert.it/logos/brands/infocert/white.svg" 
            alt="InfoCert Logo" 
            className="d-inline-block align-top"
            width="160"
          ></img>
        </Navbar.Brand>
      </Navbar>

      <div className="row px-lg-5 px-md-5 mx-lg-5">
        <div className="px-lg-5">
          <React.Suspense fallback={<Loader />}>
            <Card className="container shadow">
              <div className="border border-2 border-secondary rounded mt-3 mb-4 px-5"></div>
              <Card.Body className="px-5 text-center">
                <div className="px-lg-5">
                  {resultView}
                </div>
              </Card.Body>
            </Card>
          </React.Suspense>
        </div>
      </div>
    </div>
  );
}

export default App;
